<template>
  <div class="home-header">
    <div class="header-img-section">
      <div
        id="header-title"
        class="header-title"
      >
        <div
          v-if="configData.base.header && configData.base.header.image"
        >
          <vue-load-image>
            <b-img
              slot="image"
              :src="configData.base.header.image"
              fluid
              alt="header"
            />
            <b-img
              slot="preloader"
              :src="require('@/assets/images/items/loading-2.png')"
              width="60"
              height="60"
              alt="header"
            />
          </vue-load-image>
        </div>
      </div>

      <div class="header-more d-flex d-md-none">
        <a
          class="scrolldown"
          href="#container-1"
          aria-label="Swipe to the latest news block"
          passive="true"
        >
          <div class="chevrons">
            <div class="chevrondown" />
            <div class="chevrondown" />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'
import VueLoadImage from 'vue-load-image'

export default {
  components: {
    BImg,
    VueLoadImage,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  mounted() {
    if (this.configData.base.header && this.configData.base.header.image) {
      this.configData.base.header.image = `${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.base.header.image) : this.configData.base.header.image}`
    }
  },
  methods: {
    // (網頁)跳轉
    redirectLink(link) {
      if (!link) return
      window.location.assign(link)
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
}
</script>

<style lang="scss" scoped>
.home-header {
  // padding-top: 30vw;;
  position: relative;
  .header-title {
    width: 100vw;
    min-height: 65vh;
    padding: 10vw 5vh 0 5vh;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-height: 500px;
    }
  }
  .header-default-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 90%;
    max-height: 100%;
    width: 600px;
    height: 300px;
    border: 3px dashed #1d1d1d;
    border-radius: 10px;
    background-color: #fff;
    &.sm {
      min-width: 300px;
      width: 100%;
    }
  }
  .header-more{
    position: absolute;
    bottom: 10vh;
    left: 50%;
    transform: translateX(-50%);
    visibility: hidden;
    display: flex;
    justify-content: center;
    align-content: end;

    .scrolldown  {
      --color: white;
      --sizeX: 30px;
      --sizeY: 50px;
      position: relative;
      width: var(--sizeX);
      height: var(--sizeY);
      margin-left: var(sizeX / 2);
      border: calc(var(--sizeX) / 10) solid var(--color);
      border-radius: 50px;
      box-sizing: border-box;
      margin-bottom: 16px;
      cursor: pointer;
    }

    .scrolldown::before {
      content: "";
      position: absolute;
      bottom: 30px;
      left: 50%;
      width: 6px;
      height: 6px;
      margin-left: -3px;
      background-color: var(--color);
      border-radius: 100%;
      animation: scrolldown-anim 2s infinite;
      box-sizing: border-box;
      box-shadow: 0px -5px 3px 1px #2a547066;
    }

    @keyframes scrolldown-anim {
      0% {
        opacity: 0;
        height: 6px;
      }

      40% {
        opacity: 1;
        height: 10px;
      }

      80% {
        transform: translate(0, 20px);
        height: 10px;
        opacity: 0;
      }

      100% {
        height: 3px;
        opacity: 0;
      }
    }

    .chevrons {
      padding: 6px 0 0 0;
      margin-left: -3px;
      margin-top: 48px;
      width: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .chevrondown {
      margin-top: -6px;
      position: relative;
      border: solid var(--color);
      border-width: 0 3px 3px 0;
      display: inline-block;
      width: 10px;
      height: 10px;
      transform: rotate(45deg);
    }

    .chevrondown:nth-child(odd) {
      animation: pulse54012 500ms ease infinite alternate;
    }

    .chevrondown:nth-child(even) {
      animation: pulse54012 500ms ease infinite alternate 250ms;
    }

    @keyframes pulse54012 {
      from {
        opacity: 0;
      }

      to {
        opacity: 0.5;
      }
    }
    // position: fixed;
    // bottom: 10vh;
  }
}

@media screen and (max-width: 767px) {
  .home-header {
    .header-img-section {
      height: 100vh;
    }
    .header-more {
      visibility: visible !important;
    }
  }
}
// @media screen and (max-width: 576px){
//   .home-header {
//     .header-title {
//       padding: 0 !important;
//     }

//     .header-more {
//       visibility: visible !important;
//       display: flex;
//       justify-content: center;
//       align-content: end;
//       margin-bottom: calc(10vh);
//     }
//   }
// }
</style>
